import { useFormContext } from "react-hook-form";
import CustomerBaseExtraAddress from "./CustomerBaseExtraAddress";
import { IFormValues } from "../../types";
import { Grid } from "@mui/material/index";
import { SyntheticEvent } from "react";

interface CustomerBaseExtraAddressListProps {
    isCreationMode: boolean,
    onRemove: (event: SyntheticEvent, index: number, selectedExtraAddress: any) => void,
}

const CustomerBaseExtraAddressList = ({isCreationMode, onRemove}: CustomerBaseExtraAddressListProps) => {

    const { getValues } = useFormContext<IFormValues>();

    return (
        <>
            {getValues("cbExtraAddresses")?.map((addr, index) => (
                <Grid item md={12} xs={12} key={`cb-extra-address-${addr.idAssociation}-${addr.customerId}-${addr.bpCode}-${index}`}>
                    <CustomerBaseExtraAddress 
                        index={index}
                        isCreationMode={isCreationMode}
                        onRemove={onRemove}
                    />
                </Grid>
            ))}
        </>
    )
}

export default CustomerBaseExtraAddressList;